import { MenuItem } from 'primeng/api';


export const ItemsLayoutMainOptions: MenuItem[] = [
  {
    automationId: 'PR_000',
    label: 'menu_main.products',
    icon: 'pi pi-fw pi-tags',
    routerLink: 'products/list',
    tooltip: 'main_layout.products_description',
  },
  {
    automationId: 'PR_001',
    label: 'menu_main.products_stock',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'products/stock',
    tooltip: 'main_layout.inventories_description',
  },
  {
    automationId: 'ADM_000',
    label: 'menu_main.admin_warehouse',
    icon: 'pi pi-fw pi-building',
    routerLink: 'administration/locations/warehouses',
    tooltip: 'main_layout.admin_warehouse_description',
  },
  {
    automationId: 'PL_000',
    label: 'menu_main.planning_users',
    icon: 'pi pi-fw pi-users',
    routerLink: 'planning/users-config',
    tooltip: 'main_layout.planning_users_description',
  },
  {
    automationId: 'RE_000',
    label: 'menu_main.purchase_orders',
    icon: 'pi pi-fw pi-cart-plus',
    routerLink: 'reception/purchase-list',
    tooltip: 'main_layout.purchase_orders_description',
  },
  {
    automationId: 'OR_000',
    label: 'menu_main.orders',
    icon: 'pi pi-fw pi-verified',
    routerLink: 'operations/orders-list',
    tooltip: 'main_layout.orders_description',
  },
  {
    automationId: 'IN_002',
    label: 'menu_main.inventory',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'inventory/physical-count-list',
    tooltip: 'main_layout.inventory_description',
  },
];

/**
 * Array objects for main-sibedar menu
 * @type {MenuItem[]} Array for objects compatible with menu primeng
 *
 */
export const ItemsMenu: MenuItem[] = [
  {
    label: 'menu_main.dashboards',
    icon: 'pi pi-fw pi-chart-line',
    visible: true,
    routerLink: 'dashboards',
    items: [],
  },
  {
    automationId: 'ADMINISTRATION',
    label: 'menu_main.admin',
    icon: 'pi pi-fw pi-cog',
    visible: true,
    items: [
      {
        automationId: 'ADMINISTRATION',
        label: 'menu_main.admin_warehouse',
        icon: 'pi pi-fw pi-building',
        routerLink: 'administration/locations/warehouses',
      },
      {
        automationId: 'ADMINISTRATION',
        label: 'menu_main.admin_locations',
        icon: 'pi pi-fw pi-inbox',
        routerLink: 'administration/locations/positions',
      },
      {
        automationId: 'ADMINISTRATION',
        label: 'menu_main.admin_users',
        icon: 'pi pi-fw pi-user-edit',
        routerLink: 'administration/users/list',
      },
      {
        automationId: 'CONTAINER_CODES',
        label: 'menu_main.container_management',
        icon: 'pi pi-fw pi-box',
        items: [
          {
            label: 'menu_main.container_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'administration/containers/list',
          },
        ],
      },
    ],
  },
  {
    automationId: 'PLANNING',
    label: 'menu_main.operations',
    icon: 'pi pi-fw pi-briefcase',
    visible: true,
    items: [
      {
        automationId: 'PLANNING',
        label: 'menu_main.thirds',
        icon: 'pi pi-fw pi-users',
        items: [
          {
            automationId: 'PLANNING',
            label: 'menu_main.thirds_new',
            icon: 'pi pi-fw pi-user-plus',
            routerLink: 'third-parties/create',
            visible: false,
          },
          {
            automationId: 'PLANNING',
            label: 'menu_main.thirds_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'third-parties/list',
          },
        ],
      },
      {
        automationId: 'PLANNING',
        label: 'menu_main.products',
        icon: 'pi pi-fw pi-tags',
        items: [
          {
            automationId: 'PLANNING',
            label: 'menu_main.products_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'products/list',
          },
          {
            automationId: 'PLANNING',
            label: 'menu_main.products_stock',
            icon: 'pi pi-fw pi-table',
            routerLink: 'products/stock',
          },
        ],
      },
      {
        automationId: 'PLANNING',
        label: 'menu_main.planning',
        icon: 'pi pi-fw pi-list',
        items: [
          {
            automationId: 'PLANNING',
            label: 'menu_main.planning_users',
            icon: 'pi pi-fw pi-users',
            routerLink: 'planning/users-config',
          },
          {
            automationId: 'PLANNING',
            label: 'menu_main.planning_enlist',
            icon: 'pi pi-fw pi-shopping-cart',
            routerLink: 'planning/enlistment-config',
          },
          {
            automationId: 'PLANNING',
            label: 'menu_main.planning_dispatch',
            icon: 'pi pi-fw pi-truck',
            routerLink: 'planning/dispatch-config',
          },
        ],
      },
      {
        automationId: 'RECEPTION',
        label: 'menu_main.receiving',
        icon: 'pi pi-fw pi-truck',
        items: [
          {
            automationId: 'RECEPTION',
            label: 'menu_main.purchase_orders',
            icon: 'pi pi-fw pi-cart-plus',
            routerLink: 'reception/purchase-list',
          },
          {
            automationId: 'RECEPTION',
            label: 'menu_main.transfer_orders',
            icon: 'pi pi-fw pi-truck',
            routerLink: 'reception/transfer-list',
          },
          {
            automationId: 'RECEPTION',
            label: 'menu_main.return_orders',
            icon: 'pi pi-fw pi-refresh',
            routerLink: 'reception/return-list',
          },
        ],
      },
      {
        automationId: 'ORDERS',
        label: 'menu_main.orders',
        icon: 'pi pi-fw pi-file',
        items: [
          {
            automationId: 'ORDERS',
            label: 'menu_main.orders_states',
            icon: 'pi pi-fw pi-verified',
            routerLink: 'operations/orders-list',
          },
          {
            automationId: 'ORDERS',
            label: 'menu_main.enlistment_task',
            icon: 'pi pi-fw pi-file-edit',
            routerLink: 'operations/enlistment-list',
          },
          {
            automationId: 'ORDERS',
            label: 'menu_main.dispatches_task',
            icon: 'pi pi-fw pi-file-export',
            routerLink: 'operations/dispatch-list',
          },
        ],
      },
      {
        automationId: 'INVENTORY',
        label: 'menu_main.inventory',
        icon: 'pi pi-fw pi-calculator',
        items: [
          {
            automationId: 'INVENTORY',
            label: 'menu_main.inventory_counts',
            icon: 'pi pi-fw pi-calendar',
            routerLink: 'inventory/physical-count-programming',
          },
          {
            automationId: 'INVENTORY',
            label: 'menu_main.inventory_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'inventory/physical-count-list',
          },
        ],
      },
      {
        automationId: 'REFUEL',
        label: 'menu_main.replenishment',
        icon: 'pi pi-fw pi-sync',
        items: [
          {
            automationId: 'REFUEL',
            label: 'menu_main.replenishment_configs',
            icon: 'pi pi-fw pi-sliders-h',
            routerLink: 'replenishment/configs',
          },
          {
            automationId: 'REFUEL',
            label: 'menu_main.replenishment_tasks',
            icon: 'pi pi-fw pi-list-check',
            routerLink: 'replenishment/tasks',
          },
        ],
      },
    ],
  },
  {
    automationId: 'APPLICATIONS',
    label: 'menu_main.applications',
    icon: 'pi pi-fw pi-th-large',
    visible: true,
    items: [
      {
        automationId: 'APPLICATIONS',
        label: 'menu_main.webhooks',
        icon: 'pi pi-fw pi-link',
        routerLink: 'apps/webhooks/list',
      },
    ],
  },
];
